export const CAPTURE_TYPE_AUTO = 'Auto';
export const CAPTURE_TYPE_IPHONE_VIMMERSE = 'iPhone-Vimmerse';
export const CAPTURE_TYPE_IPHONE_RECORD3D = 'iPhone-Record3D';
export const CAPTURE_TYPE_MULTI_CAMERA_MIV = 'MultiCamera-MIV';
export const CAPTURE_TYPE_MULTI_KINECT_DEPTH_KIT = 'MultiKinect-Depthkit';
export const CAPTURE_TYPE_MULTI_KINECT_OPEN3D = 'MultiKinect-Open3D';
export const CAPTURE_TYPE_3DVIDEO_VIMMERSE = '3dVideo-Vimmerse';

export const CAPTURE_OPTIONS = [
  {
    value: CAPTURE_TYPE_AUTO,
    label: 'Auto'
  },
  {
    value: CAPTURE_TYPE_MULTI_KINECT_DEPTH_KIT,
    label: 'Azure Kinect - Depthkit'
  },
  { value: CAPTURE_TYPE_IPHONE_VIMMERSE, label: 'iPhone - Vimmerse' },
  { value: CAPTURE_TYPE_IPHONE_RECORD3D, label: 'iPhone - Record3D' },
  { value: CAPTURE_TYPE_MULTI_CAMERA_MIV, label: 'Multi Camera - MIV' },
  { value: CAPTURE_TYPE_MULTI_KINECT_OPEN3D, label: 'Azure Kinect - Open3D' },
  { value: CAPTURE_TYPE_3DVIDEO_VIMMERSE, label: '3DVideo - Vimmerse' }
];

export const PROCESSING_STATUS_NEW = 'new';

export const PROCESSING_STATUS_QUEUE_SOURCE = 'queue_source';
export const PROCESSING_STATUS_PROCESSING_SOURCE = 'processing_source';
export const PROCESSING_STATUS_SUCCESS_SOURCE = 'success_source';
export const PROCESSING_STATUS_FAILED_SOURCE = 'failed_source';

export const PROCESSING_STATUS_QUEUE_3D = 'queue_3d';
export const PROCESSING_STATUS_PROCESSING_3D = 'processing_3d';
export const PROCESSING_STATUS_SUCCESS_3D = 'success_3d';
export const PROCESSING_STATUS_FAILED_3D = 'failed_3d';

export const PROCESSING_STATUS_QUEUE_BULLET = 'queue_bullet';
export const PROCESSING_STATUS_PROCESSING_BULLET = 'processing_bullet';
export const PROCESSING_STATUS_FAILED_BULLET = 'failed_bullet';

export const PROCESSING_STATUS_PROCESSING = 'processing';
export const PROCESSING_STATUS_SUCCESS = 'success';
export const PROCESSING_STATUS_FAIL = 'fail';

export const PROCESSING_STATUS_ACTION_REQUIRED = 'action required';
export const PROCESSING_STATUS_CANCEL = 'cancel';

export const STATUS_STRING_MAP = {
  [PROCESSING_STATUS_NEW]: 'New',
  [PROCESSING_STATUS_QUEUE_SOURCE]: 'Waiting for source generation',
  [PROCESSING_STATUS_PROCESSING_SOURCE]: 'Generating source',
  [PROCESSING_STATUS_SUCCESS_SOURCE]: 'Generated source',
  [PROCESSING_STATUS_FAILED_SOURCE]: 'Failed source generation',
  [PROCESSING_STATUS_QUEUE_3D]: 'Waiting for 3D generation',
  [PROCESSING_STATUS_PROCESSING_3D]: 'Generating 3D media',
  [PROCESSING_STATUS_SUCCESS_3D]: 'Generated 3D media',
  [PROCESSING_STATUS_FAILED_3D]: 'Failed 3D generation',
  [PROCESSING_STATUS_QUEUE_BULLET]: 'Waiting for bullet video generation',
  [PROCESSING_STATUS_PROCESSING_BULLET]: 'Processing bullet video',
  [PROCESSING_STATUS_SUCCESS]: 'Success',
  [PROCESSING_STATUS_FAILED_BULLET]: 'Failed bullet video generation',
  [PROCESSING_STATUS_ACTION_REQUIRED]: 'Action required',
  [PROCESSING_STATUS_CANCEL]: 'Cancelled'
};

export const PUBLIC_STATUS_PUBLIC = '2';
export const PUBLIC_STATUS_UNLISTED = '1';
export const PUBLIC_STATUS_PRIVATE = '0';

export const PUBLIC_STATUS_OPTIONS = [
  { value: PUBLIC_STATUS_UNLISTED, label: 'Unlisted' },
  { value: PUBLIC_STATUS_PUBLIC, label: 'Public' },
  { value: PUBLIC_STATUS_PRIVATE, label: 'Private' }
];

export const ENV_OPTIONS = [
  { value: 'prod', label: 'Production' },
  { value: 'dev', label: 'Development' }
];
export const AI_TYPES = [
  'Auto',
  'AutoT1',
  'AutoT3',
  'TryOnVideo',
  'KlingAI',
  'KlingT3',
  'MinimaxHailuo',
  'Hunyuan',
  'Wan',
  'Pixverse',
  'PixverseT3',
  'GoogleOmni',
  'Veo',
  'VeoFast',
  'VeoLite',
  'Grok',
  'Vidu',
  'Sora',
  'SoraPro',
  'Seedance',
  'SeedanceFast',
  'SeedanceT6',
  'HappyHorse',
  'LumaAI',
  'LumaRay2',
  'RunwayML',
  'PVideo',
  'StaticMotion'
];

export const AI_SERVICES = [
  'StableVideoDiffusion',
  'LeonardoMotion',
  'HaiperVideo',
  'KlingAI',
  'KlingT3',
  'MinimaxHailuo',
  'Hunyuan',
  'Wan',
  'Pixverse',
  'PixverseT3',
  'PVideo',
  'StaticMotion',
  'GoogleOmni',
  'Veo',
  'VeoFast',
  'VeoLite',
  'Grok',
  'Vidu',
  'Sora',
  'SoraPro',
  'Seedance',
  'SeedanceFast',
  'SeedanceT6',
  'HappyHorse',
  'LumaAI',
  'LumaRay2',
  'RunwayML'
];

export const ANIMATEAI_QUANTITY = 1;

export const DEFAULT_POSE_PRESET_PARAMS =
  'MotionAmount=5|MotionLength=5.0|Loop=1';
export const DEFAULT_POSE_PRESET = {
  MotionType: 'Parallax',
  Params: 'CameraPath=StepIn|' + DEFAULT_POSE_PRESET_PARAMS
};

export const MOTION_TYPE_OPTIONS = [
  { value: 'Auto', label: 'Auto' },
  { value: 'AutoT1', label: 'AutoT1' },
  { value: 'AutoT3', label: 'AutoT3' },
  { value: 'TryOnVideo', label: 'TryOnVideo' },
  { value: 'KlingAI', label: 'KlingAI' },
  { value: 'KlingT3', label: 'KlingT3' },
  { value: 'MinimaxHailuo', label: 'MinimaxHailuo' },
  { value: 'HappyHorse', label: 'HappyHorse' },
  { value: 'Pixverse', label: 'Pixverse' },
  { value: 'PixverseT3', label: 'PixverseT3' },
  { value: 'Seedance', label: 'Seedance' },
  { value: 'SeedanceFast', label: 'SeedanceFast' },
  { value: 'SeedanceT6', label: 'SeedanceT6' },
  { value: 'Sora', label: 'Sora' },
  { value: 'SoraPro', label: 'SoraPro' },
  { value: 'LumaAI', label: 'LumaAI' },
  { value: 'LumaRay2', label: 'LumaRay2' },
  { value: 'GoogleOmni', label: 'GoogleOmni' },
  { value: 'Veo', label: 'Veo' },
  { value: 'VeoFast', label: 'VeoFast' },
  { value: 'VeoLite', label: 'VeoLite' },
  { value: 'Grok', label: 'Grok' },
  { value: 'Vidu', label: 'Vidu' },
  { value: 'RunwayML', label: 'RunwayML' },
  { value: 'Hunyuan', label: 'Hunyuan' },
  { value: 'PicoMotion', label: 'PicoMotion' },
  { value: 'PVideo', label: 'PVideo' },
  { value: 'StaticMotion', label: 'StaticMotion' },
  { value: 'Wan', label: 'Wan' },
];

export const DEFAULT_GENERATE_AI = {
  tool: 'Text2Image', //# options: 'Text2Image', 'Reimagine', 'Inpaint', 'Cleanup', 'ReplaceBackground', 'RemoveBackground', 'Recrop', 'RemoveText', 'Sketch2Image', 'Instruct-pix2pix', 'ControlNet', 'Enhance'
  quantity: '1',
  input: 'prompt=Shot of Nike shoes on colorful background',
  params: 'option=|',
  output: 'ai_image.png',
  type: 'source'
};

export const SUPPORTED_AUDIO_FORMATS = ['aac', 'mp3', 'ogg', 'wav', 'm4a'];
export const SUPPORTED_IMAGE_FORMATS = [
  'png',
  'jpg',
  'jpeg',
  'svg',
  'heif',
  'heic',
  'webp',
  'tif',
  'tiff',
  'bmp',
  'psd',
  'avif',
  'jfif'
];
export const SUPPORTED_VIDEO_FORMATS = ['mp4', 'mov', 'gif', 'mkv', 'ogv'];

export const VIDEO_MIME_TYPES = [
  'video/mp4',
  'video/quicktime',
  'video/x-matroska',
  'video/ogg',
  'video/webm',
  'video/mpeg',
  'video/x-m4v',
  'video/x-flv',
  'video/x-msvideo',
  'video/x-ms-wmv'
];

export const IMAGE_MIME_TYPES = [
  'image/gif',
  'image/png',
  'image/jpeg',
  'image/svg+xml',
  'image/heif',
  'image/heic',
  'image/webp',
  'image/tiff',
  'image/bmp',
  'image/vnd.adobe.photoshop',
  'image/avif'
];

export const FILE_TYPE_OPTIONS = [
  { value: 'Texture', label: 'Texture' },
  { value: 'Depth', label: 'Depth' },
  { value: 'Mask', label: 'Mask' },
  { value: 'BG Texture', label: 'BG Texture' },
  { value: 'BG Depth', label: 'BG Depth' },
  { value: 'Metadata', label: 'Metadata' },
  { value: 'Audio', label: 'Audio' },
  { value: 'PoseTrace', label: 'PoseTrace' },
  { value: 'Config', label: 'Config' },
  { value: 'Unknown', label: 'Unknown' },
  { value: 'Skip', label: 'Skip' }
];

export const VIMMERSE_CUSTOMER_ID = 'vimmerse-product';
export const VIMMERSE_CREATOR_ID = 'vimmerse-creator';

export const PIPELINE_PRESET_NORMAL = 'Normal';
export const PIPELINE_PRESET_FAST = 'Fast';

export const DEFAULT_SUBMIT_PARAMS = {
  creation_version: '1',
  scale_factor: '1',
  rotation: '0',
  mask_source: 'Auto',
  mask_processing: 'Auto',
  sound_effects: 'No',
  extend_video: 'No',
  depth_processing: 'Auto',
  erosion_radius: '5',
  background_processing: 'Auto',
  stabilize_motion: 'No',
  virtual_views: '-1',
  virtual_motion_amount: '4',
  renderer_type: 'Auto',
  random_seed: 'Yes',
  nsfw_filter_type: 'Auto',
  pipeline_preset: PIPELINE_PRESET_NORMAL
};

export const GENERATE_ALL = 'GENERATE_ALL';
export const GENERATE_AI = 'GENERATE_AI';
export const GENERATE_SOURCE = 'GENERATE_SOURCE';
export const GENERATE_3D = 'GENERATE_3D';
export const GENERATE_BULLET = 'GENERATE_BULLET';
export const GENERATE_VIDEO = 'GENERATE_VIDEO';

export const DEFAULT_GENERATE_TYPE = GENERATE_VIDEO;

export const PROCESSING_STATUS_OPTIONS = [
  {
    value: PROCESSING_STATUS_NEW,
    label: STATUS_STRING_MAP[PROCESSING_STATUS_NEW]
  },
  {
    value: PROCESSING_STATUS_QUEUE_SOURCE,
    label: STATUS_STRING_MAP[PROCESSING_STATUS_QUEUE_SOURCE]
  },
  {
    value: PROCESSING_STATUS_PROCESSING_SOURCE,
    label: STATUS_STRING_MAP[PROCESSING_STATUS_PROCESSING_SOURCE]
  },
  {
    value: PROCESSING_STATUS_SUCCESS_SOURCE,
    label: STATUS_STRING_MAP[PROCESSING_STATUS_SUCCESS_SOURCE]
  },
  {
    value: PROCESSING_STATUS_FAILED_SOURCE,
    label: STATUS_STRING_MAP[PROCESSING_STATUS_FAILED_SOURCE]
  },
  {
    value: PROCESSING_STATUS_QUEUE_3D,
    label: STATUS_STRING_MAP[PROCESSING_STATUS_QUEUE_3D]
  },
  {
    value: PROCESSING_STATUS_PROCESSING_3D,
    label: STATUS_STRING_MAP[PROCESSING_STATUS_PROCESSING_3D]
  },
  {
    value: PROCESSING_STATUS_SUCCESS_3D,
    label: STATUS_STRING_MAP[PROCESSING_STATUS_SUCCESS_3D]
  },
  {
    value: PROCESSING_STATUS_FAILED_3D,
    label: STATUS_STRING_MAP[PROCESSING_STATUS_FAILED_3D]
  },
  {
    value: PROCESSING_STATUS_QUEUE_BULLET,
    label: STATUS_STRING_MAP[PROCESSING_STATUS_QUEUE_BULLET]
  },
  {
    value: PROCESSING_STATUS_PROCESSING_BULLET,
    label: STATUS_STRING_MAP[PROCESSING_STATUS_PROCESSING_BULLET]
  },
  {
    value: PROCESSING_STATUS_SUCCESS,
    label: STATUS_STRING_MAP[PROCESSING_STATUS_SUCCESS]
  },
  {
    value: PROCESSING_STATUS_FAILED_BULLET,
    label: STATUS_STRING_MAP[PROCESSING_STATUS_FAILED_BULLET]
  },
  {
    value: PROCESSING_STATUS_ACTION_REQUIRED,
    label: STATUS_STRING_MAP[PROCESSING_STATUS_ACTION_REQUIRED]
  }
];

// Workflow-specific status constants (matching backend constants.py)
export const WORKFLOW_STATUS_NEW = 'new';
export const WORKFLOW_STATUS_PROCESSING = 'processing';
export const WORKFLOW_STATUS_SUCCESS = 'success';
export const WORKFLOW_STATUS_FAIL = 'fail';

export const WORKFLOW_STATUS_STRING_MAP = {
  [WORKFLOW_STATUS_NEW]: 'New',
  [WORKFLOW_STATUS_PROCESSING]: 'Processing',
  [WORKFLOW_STATUS_SUCCESS]: 'Success',
  [WORKFLOW_STATUS_FAIL]: 'Fail'
};

export const WORKFLOW_STATUS_OPTIONS = [
  {
    value: WORKFLOW_STATUS_NEW,
    label: WORKFLOW_STATUS_STRING_MAP[WORKFLOW_STATUS_NEW]
  },
  {
    value: WORKFLOW_STATUS_PROCESSING,
    label: WORKFLOW_STATUS_STRING_MAP[WORKFLOW_STATUS_PROCESSING]
  },
  {
    value: WORKFLOW_STATUS_SUCCESS,
    label: WORKFLOW_STATUS_STRING_MAP[WORKFLOW_STATUS_SUCCESS]
  },
  {
    value: WORKFLOW_STATUS_FAIL,
    label: WORKFLOW_STATUS_STRING_MAP[WORKFLOW_STATUS_FAIL]
  }
];

export const UPLOAD_TO_UPLOAD = 'UPLOAD';
export const UPLOAD_TO_SOURCE = 'SOURCE';

export const QUEUE_TYPE_BATCH = 'BATCH';
export const QUEUE_TYPE_NORMAL = 'NORMAL';

export const BATCH_STATUS_NEW = 'new';
export const BATCH_STATUS_PROCESSING = 'processing';
export const BATCH_STATUS_PROCESSED = 'processed';
export const BATCH_STATUS_SUCCESS = 'success';
export const BATCH_STATUS_FAIL = 'fail';
export const BATCH_STATUS_READY = 'ready';
export const BATCH_STATUS_PAID = 'paid';

export const BATCH_STATUS_OPTIONS = [
  {
    value: BATCH_STATUS_NEW,
    label: BATCH_STATUS_NEW.toUpperCase()
  },
  {
    value: BATCH_STATUS_PROCESSING,
    label: BATCH_STATUS_PROCESSING.toUpperCase()
  },
  {
    value: BATCH_STATUS_PROCESSED,
    label: BATCH_STATUS_PROCESSED.toUpperCase()
  },
  {
    value: BATCH_STATUS_SUCCESS,
    label: BATCH_STATUS_SUCCESS.toUpperCase()
  },
  {
    value: BATCH_STATUS_FAIL,
    label: BATCH_STATUS_FAIL.toUpperCase()
  },
  {
    value: BATCH_STATUS_READY,
    label: BATCH_STATUS_READY.toUpperCase()
  },
  {
    value: BATCH_STATUS_PAID,
    label: BATCH_STATUS_PAID.toUpperCase()
  }
];

export const DISCOUNT_OPTIONS = [
  { value: '0', label: '0%' },
  { value: '5', label: '5%' },
  { value: '10', label: '10%' },
  { value: '20', label: '20%' },
  { value: '30', label: '30%' },
  { value: '50', label: '50%' },
  { value: '70', label: '70%' },
  { value: '90', label: '90%' },
  { value: '100', label: '100%' }
];

export const IMPORTANT_CUSTOMERS = [
  'vimmerse-product',
  'canva',
  'canvaremake',
  'canvatryon',
  'adobe',
  'shopify',
  'imgix',
  'showtimepictures',
  'eachlabs',
  'wildmedia'
];

export const VIMMERSE_CUSTOMERS = [
  'vimmerse-test-user',
  'admin_test',
]

export const RATING_OPTIONS = [
  { value: '-1', label: 'No Ratings' },
  { value: '1', label: '1' },
  { value: '2', label: '2' },
  { value: '3', label: '3' },
  { value: '4', label: '4' },
  { value: '5', label: '5' }
];

export const VCV_SERVER_MAP = [
  {
    name: 'VCV TOOL 1',
    ip: '164.52.147.242'
  },
  {
    name: 'VCV TOOL 2',
    ip: '164.52.147.243'
  },
  {
    name: 'VCV TOOL 3',
    ip: '164.52.147.244'
  },
  {
    name: 'VCV TOOL 4',
    ip: '164.52.147.245'
  },
];

export const JENKINS_ADDRESSES = [
  {
    ip: '164.52.147.242',
    jenkins: 'https://vcv-1-a100-jenkins.vimmerse.io'
  },
  {
    ip: '164.52.147.243',
    jenkins: 'https://vcv-2-a100-jenkins.vimmerse.io'
  },
  {
    ip: '164.52.147.244',
    jenkins: 'https://vcv-3-a100-jenkins.vimmerse.io'
  },
  {
    ip: '164.52.147.245',
    jenkins: 'https://vcv-4-a100-jenkins.vimmerse.io'
  },
  {
    ip: '129.146.6.109',
    jenkins: 'https://lambdalabs-jenkins-a100-4.vimmerse.io'
  },
  {
    ip: '129.146.39.242',
    jenkins: 'https://lambdalabs-jenkins-a100-9.vimmerse.io'
  },
  {
    ip: '129.213.147.106',
    jenkins: 'https://lambdalabs-jenkins-a100-test.vimmerse.io'
  },
  {
    ip: '129.80.105.160',
    jenkins: 'https://lambdalabs-jenkins-a100-17.vimmerse.io'
  },
  {
    ip: '129.146.4.30',
    jenkins: 'https://lambdalabs-jenkins-a100-2.vimmerse.io'
  },
  {
    ip: '129.213.93.244',
    jenkins: 'https://lambdalabs-jenkins-a100-3.vimmerse.io/'
  },
  {
    ip: '35.80.212.56',
    jenkins: 'https://vimmerse-api-jenkins.vimmerse.io/'
  },
  {
    ip: '44.234.194.111',
    jenkins: 'https://vimmerse-api-jenkins-2.vimmerse.io/'
  },
  {
    ip: '54.70.145.123',
    jenkins: 'https://vimmerse-api-jenkins-3.vimmerse.io/'
  },
  {
    ip: '44.235.204.247',
    jenkins: 'https://vimmerse-api-jenkins4.vimmerse.io/'
  }
];

export const PRICE_ID_STANDARD = 'price_1PIhvAICs2gSRULGfThpBD9S';
export const PRICE_ID_PRO = 'price_1PIhv7ICs2gSRULGmtOLv2x2';
export const PRICE_ID_BUSINESS = 'price_1PIhv4ICs2gSRULGlWo23pnX';
export const PRICE_ID_ENTERPRISE = 'price_1PIhv0ICs2gSRULGNtYwH2oA';
export const CREDITS_STANDARD = 1000;
export const CREDITS_PRO = 10000;
export const CREDITS_BUSINESS = 100000;
export const CREDITS_ENTERPRISE = 1000000;

export const PRICE_PLANS = {
  standard: {
    price_id: PRICE_ID_STANDARD,
    credits: CREDITS_STANDARD,
    description: '1K credits for $14'
  },
  pro: {
    price_id: PRICE_ID_PRO,
    credits: CREDITS_PRO,
    description: '10K credits for $120'
  },
  business: {
    price_id: PRICE_ID_BUSINESS,
    credits: CREDITS_BUSINESS,
    description: '100K credits for $1000'
  },
  enterprise: {
    price_id: PRICE_ID_ENTERPRISE,
    credits: CREDITS_ENTERPRISE,
    description: '1M credits for $9000'
  }
};

export const AI_TOOL_STATUS_RUNNING = 'RUNNING';
export const AI_TOOL_STATUS_REQUESTING = 'REQUESTING';
export const AI_TOOL_STATUS_FINISHED = 'FINISHED';
export const AI_TOOL_STATUS_FAILED = 'FAILED';

export const AI_TOOL_STATUS_NEW = 'REQUESTING';
export const AI_TOOL_STATUS_REQUESTED = 'REQUESTING';

export const ASSET_STATUS_OPTIONS = [
  { value: '', label: 'All' },
  { value: 'requested', label: 'Requested' },
  { value: 'processing', label: 'Processing' },
  { value: 'success', label: 'Success' },
  { value: 'nsfw', label: 'NSFW' },
  { value: 'failed', label: 'Failed' }
];

export const KNOWN_VIDEO_OPTIONS = new Set([
  ...AI_TYPES,
  ...AI_SERVICES,
  'Text2Video',
  'Image2Video',
  'Video2Video',
  'TryOnVideo',
  'Parallax',
  'Prompt',
  'PicoMotion',
  'DynamiCrafter',
  'create_video',
  'transition_2_video',
  'reference_2_video',
  'publish_video_with_logo'
]);

export const KNOWN_VIDEO_OPTIONS_LOWER = new Set(
  Array.from(KNOWN_VIDEO_OPTIONS).map(opt => opt.toLowerCase())
);

const VIDEO_SUBSTRINGS = [
  'video',
  'motion',
  'kling',
  'minimax',
  'hailuo',
  'googleomni',
  'happyhorse',
  'seedance',
  'wan',
  'hunyuan',
  'veo',
  'sora',
  'vidu',
  'luma',
  'runway',
  'pixverse',
  'pvideo',
  'cogvideo',
  'svd',
  't2v',
  'i2v',
  'v2v',
  'parallax',
  'prompt',
  'dynamicrafter',
  'animate'
];

export const isVideoOption = option => {
  if (!option || typeof option !== 'string') return false;
  const opt = option.trim();
  const lower = opt.toLowerCase();

  // Upload options are never generations
  if (lower.includes('upload')) return false;

  // Exact set match (original case or lower case)
  if (KNOWN_VIDEO_OPTIONS.has(opt) || KNOWN_VIDEO_OPTIONS_LOWER.has(lower)) {
    return true;
  }

  // Substring keywords match
  if (VIDEO_SUBSTRINGS.some(kw => lower.includes(kw))) {
    return true;
  }

  return false;
};

export const KNOWN_IMAGE_OPTIONS = new Set([
  'Text2Image',
  'Image2Image',
  'Reimagine',
  'Inpaint',
  'Cleanup',
  'ReplaceBackground',
  'RemoveBackground',
  'Recrop',
  'RemoveText',
  'Sketch2Image',
  'Instruct-pix2pix',
  'ControlNet',
  'Enhance',
  'Upscale',
  'crop_to_content',
  'image_2_image',
  'create_elements',
  'create_image',
  'replace_background',
  'publish_frames_with_logo',
  'Flux',
  'SDXL',
  'StableDiffusion',
  'Midjourney',
  'DallE',
  'Imagen',
  'PhotoMaker',
  'FaceSwap',
  'Headshot'
]);

export const KNOWN_IMAGE_OPTIONS_LOWER = new Set(
  Array.from(KNOWN_IMAGE_OPTIONS).map(opt => opt.toLowerCase())
);

const IMAGE_SUBSTRINGS = [
  'image',
  'inpaint',
  'cleanup',
  'reimagine',
  'background',
  'recrop',
  'removetext',
  'remove_text',
  'sketch',
  'controlnet',
  'enhance',
  'upscale',
  't2i',
  'i2i',
  'flux',
  'sdxl',
  'imagen',
  'dalle',
  'dall-e',
  'midjourney',
  'photomaker',
  'faceswap',
  'headshot'
];

export const isImageOption = option => {
  if (!option || typeof option !== 'string') return false;
  const opt = option.trim();
  const lower = opt.toLowerCase();

  // Upload options are never generations
  if (lower.includes('upload')) return false;

  // Audio options are never images
  if (
    lower.includes('audio') ||
    lower.includes('sound') ||
    lower.includes('music') ||
    lower.includes('voice')
  ) {
    return false;
  }

  // Video options are never image options
  if (isVideoOption(opt)) return false;

  // Exact set match (original case or lower case)
  if (KNOWN_IMAGE_OPTIONS.has(opt) || KNOWN_IMAGE_OPTIONS_LOWER.has(lower)) {
    return true;
  }

  // Substring keywords match
  if (IMAGE_SUBSTRINGS.some(kw => lower.includes(kw))) {
    return true;
  }

  // Fallback: any non-upload, non-audio, non-video generation is treated as image
  return true;
};

export const normalizeAIStatus = status => {
  if (!status) return '';
  const s = String(status).trim().toUpperCase();

  // Failed / Error / NSFW / Cancelled / Action Required
  if (
    s === 'FAILED' ||
    s === 'NSFW' ||
    s === 'ERROR' ||
    s === 'FAIL' ||
    s === 'CANCEL' ||
    s === 'CANCELLED' ||
    s === 'ACTION REQUIRED' ||
    s.includes('FAIL') ||
    s.includes('ERROR') ||
    s.includes('CANCEL')
  ) {
    return AI_TOOL_STATUS_FAILED;
  }

  // Finished / Success / Completed / Generated
  if (
    s === 'FINISHED' ||
    s === 'SUCCESS' ||
    s === 'COMPLETED' ||
    s.includes('SUCCESS') ||
    s.includes('FINISHED') ||
    s.includes('GENERATED')
  ) {
    return AI_TOOL_STATUS_FINISHED;
  }

  // Running / Processing / In progress
  if (
    s === 'PROCESSING' ||
    s === 'RUNNING' ||
    s === 'IN_PROGRESS' ||
    s.includes('PROCESSING') ||
    s.includes('RUNNING') ||
    s.includes('GENERATING')
  ) {
    return AI_TOOL_STATUS_RUNNING;
  }

  // Requesting / New / Requested / Pending / Queued / Waiting
  if (
    s === 'NEW' ||
    s === 'REQUESTED' ||
    s === 'REQUESTING' ||
    s === 'PENDING' ||
    s === 'QUEUED' ||
    s.includes('QUEUE') ||
    s.includes('WAITING') ||
    s.includes('REQUEST') ||
    s.includes('NEW')
  ) {
    return AI_TOOL_STATUS_REQUESTING;
  }

  return s;
};

